const getTypeColor = (pokemonType) => {
    // Si pokemonType est une chaîne JSON, on la parse
    let types = pokemonType;
    try {
        if (typeof pokemonType === 'string') {
            types = JSON.parse(pokemonType);
        }
        // On utilise le premier type pour la couleur
        const primaryType = Array.isArray(types) ? types[0] : types;

        switch (primaryType) {
            case 'Grass':
                return 'rgb(75, 255, 195)';  // Vert
            case 'Water':
                return 'rgb(75, 150, 255)';  // Bleu
            case 'Psychic':
                return '#ed5ca4';   // Violet
            case 'Fire':
                return '#d1633f';   // Orange rouge
            case 'Bug':
                return 'rgb(210, 255, 106)';   // Vert jaune
            case 'Normal':
                return '#c997a4';   // Blanc
            case 'Ground':
                return 'rgb(135, 81, 43)';   // Marron
            case 'Flying':
                return '#93afc1';   // Blanc
            case 'Poison':
                return 'rgb(97, 60, 113)';   // Violet foncé
            case 'Electric':
                return 'rgb(255, 215, 0)';   // Jaune
            case 'Fairy':
                return 'rgb(255, 173, 228)';   // Rose
            case 'Fighting':
                return 'rgb(200, 131, 91)';   // Marron clair
            case 'Rock':
                return 'rgb(135, 81, 43)';   // Marron
            case 'Ice':
                return 'rgb(129, 240, 255)';   // Bleu clair
            case 'Ghost':
                return 'rgb(84, 46, 97)';   // Violet
            case 'Dragon':
                return 'rgb(254, 255, 172)';   // Jaune clair
            case 'Steel':
                return 'rgb(174, 174, 174)';   // Gris
            case 'Dark':
                return 'rgb(84, 46, 97)';   // Violet
                
            default:
                return 'rgb(75, 255, 195)';  // Gris par défaut
        }
    } catch (error) {
        console.error('Erreur lors du parsing du type:', error);
        return 'rgb(75, 255, 195)';  // Couleur par défaut en cas d'erreur
    }
};

export default getTypeColor;